import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Types from '../Avatar/AvatarTypes';

const UserPhoto = ({ url, size }) => (
    <div
        className={cx('topbar__avatar--photo', {
            'topbar__avatar--photo-user-box': size === Types.UserBox
        })}
    >
        <img src={url} alt="user avatar" />
    </div>
);

UserPhoto.propTypes = {
    url: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired
};

export default UserPhoto;
